import * as React from 'react';
import { Route, Redirect } from 'react-router';
import { LOGIN_PATH } from '../../constants/routes';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const _renderFunction = props => {
    if (rest.access) {
      return <Component {...props} />;
    } else {
      return (
        <Redirect
          to={{
            pathname: LOGIN_PATH,
            state: { from: props.location }
          }}
        />
      );
    }
  };
  return <Route {...rest} render={_renderFunction} />;
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/helpers/PrivateRoute.js